__turbopack_context__.v({
  "hovedenhet": "Hovedenhet-module__IkpOVa__hovedenhet",
  "hovedenhetBeskrivelse": "Hovedenhet-module__IkpOVa__hovedenhetBeskrivelse",
  "hovedenhetJuridisk": "Hovedenhet-module__IkpOVa__hovedenhetJuridisk",
  "hovedenhetTekst": "Hovedenhet-module__IkpOVa__hovedenhetTekst",
  "hovedenhetTittel": "Hovedenhet-module__IkpOVa__hovedenhetTittel",
});
